import { Sparkles, TrendingUp, TrendingDown, Flame } from "lucide-react";
import { formatDateShort } from "@/lib/calendar";

function Card({ children, accent, testId }) {
  return (
    <div
      className="relative rounded-3xl p-5 overflow-hidden backdrop-blur-md border"
      style={{
        background:
          "linear-gradient(155deg, rgba(255, 251, 240, 0.82) 0%, rgba(244, 236, 215, 0.5) 100%)",
        borderColor: "rgba(218, 207, 186, 0.55)",
        boxShadow: "0 18px 50px -28px rgba(83,109,83,0.22), 0 1px 0 rgba(255,255,255,0.65) inset",
      }}
      data-testid={testId}
    >
      <span
        aria-hidden="true"
        className="absolute -bottom-12 -right-6 w-32 h-32 rounded-full opacity-50"
        style={{ background: `radial-gradient(circle, ${accent} 0%, transparent 70%)`, filter: "blur(24px)" }}
      />
      <div className="relative">{children}</div>
    </div>
  );
}

function fmt(v) {
  if (v == null) return "—";
  return Number(v).toFixed(1);
}

export default function SummaryCards({ summary }) {
  if (!summary) return null;
  const { avg_overall, best_day, worst_day, current_streak } = summary;

  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-4" data-testid="calendar-summary">
      <Card accent="rgba(141, 187, 142, 0.55)" testId="summary-avg">
        <div className="flex items-center gap-2 text-sage-700">
          <Sparkles size={14} />
          <p className="tk-label">Promedio general</p>
        </div>
        <div className="flex items-baseline gap-2 mt-2">
          <span className="font-outfit text-4xl text-ink-900">{fmt(avg_overall)}</span>
          <span className="font-dmsans text-sm text-ink-600">/ 10</span>
        </div>
        <p className="font-dmsans text-xs text-ink-600 mt-1">
          A lo largo de tu historia
        </p>
      </Card>

      <Card accent="rgba(42, 157, 143, 0.55)" testId="summary-best">
        <div className="flex items-center gap-2 text-sage-700">
          <TrendingUp size={14} />
          <p className="tk-label">Mejor día</p>
        </div>
        <div className="flex items-baseline gap-2 mt-2">
          <span className="font-outfit text-4xl text-ink-900">{fmt(best_day?.score)}</span>
        </div>
        <p className="font-dmsans text-xs text-ink-600 mt-1">
          {best_day ? formatDateShort(best_day.date) : "Sumá registros"}
        </p>
      </Card>

      <Card accent="rgba(224, 122, 95, 0.45)" testId="summary-worst">
        <div className="flex items-center gap-2" style={{ color: "#C97A60" }}>
          <TrendingDown size={14} />
          <p className="tk-label">Peor día</p>
        </div>
        <div className="flex items-baseline gap-2 mt-2">
          <span className="font-outfit text-4xl text-ink-900">{fmt(worst_day?.score)}</span>
        </div>
        <p className="font-dmsans text-xs text-ink-600 mt-1">
          {worst_day ? formatDateShort(worst_day.date) : "Sumá registros"}
        </p>
      </Card>

      <Card accent="rgba(244, 162, 97, 0.50)" testId="summary-streak">
        <div className="flex items-center gap-2" style={{ color: "#C97A60" }}>
          <Flame size={14} />
          <p className="tk-label">Racha actual</p>
        </div>
        <div className="flex items-baseline gap-2 mt-2">
          <span className="font-outfit text-4xl text-ink-900">{current_streak ?? 0}</span>
          <span className="font-dmsans text-sm text-ink-600">{current_streak === 1 ? "día" : "días"}</span>
        </div>
        <p className="font-dmsans text-xs text-ink-600 mt-1">
          {current_streak > 0 ? "Seguí así" : "Empezá hoy"}
        </p>
      </Card>
    </div>
  );
}
